import React, { Component } from 'react';
import Header from './components/Header';
import Banner from './components/Banner';
import Sections from './components/Sections';
import Footer from './components/Footer';
import './assets/css/main.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <Banner />
        <Sections />
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js